import React from "react";
import { Card, Button, Container, Row, Col } from "react-bootstrap";

import SocialMediaIcons from "../utilities/SocialMediaIcons.jsx";
import "../../style/mission.css";

import image_1 from "../../assets/cooperators/mission-book.png";
import image_2 from "../../assets/cooperators/mission-globe-book.png";
import image_3 from "../../assets/cooperators/mission-priests-books.png";

const images = [
  { image_url: image_1 },
  { image_url: image_2 },
  { image_url: image_3 },
];

const styles = {
  ul: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignContent: "center",
    paddingLeft: "3rem",
    paddingRight: "3rem",
    overflowX: "hidden",
    marginBottom: "3rem",
  },
};

function CooperatorsMission({ banners }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Card className="border-0 py-3">
        <Card.Title
          className="text-maroon font-header"
          style={{ fontSize: 30 }}
        >
          Mission
        </Card.Title>
        <Card.Body
          style={{
            maxWidth: 1100 + `px`,
            margin: 0 + ` auto`,
            textAlign: "left",
            fontSize: 20,
          }}
        >
          <Card.Subtitle className="text-maroon h2">
            Communicating the Gospel
          </Card.Subtitle>
          <Card.Text style={{ lineHeight: 1.5 }}>
            With creative vision, Fr. Alberione used modern instruments to
            proclaim the Gospel of Jesus to all people. He utilized all the
            latest media technologies to communicate the message of Jesus to
            form a Christian mentality and conscience in society.
          </Card.Text>
          <Card.Text style={{ lineHeight: 1.5 }}>
            Like him we too continually ask ourselves: Where and how and towards
            what is humanity moving, this humanity that is continually renewing
            itself on the face of the earth? and strive to imbue our society
            with the values of the Gospel. As Pauline Cooperators following in
            the footsteps of the Apostle Paul, we strive to communicate the Good
            News of Jesus Way, Truth and Life, the greatest treasure, the only
            true response to every human heart's deepest longing and search for
            meaning.
          </Card.Text>
          <Card.Text style={{ lineHeight: 1.5 }}>
            Together with the Pauline Family, and according to our specific
            vocation, we commit ourselves to prayer and to seeking to
            communicate Jesus through our lives and through the media. We do
            this in our own concrete context: in the school, at work, at home,
            in our parish and diocese, by collaborating with the different
            pastoral animation projects, by cooperating with the Pauline Family
            in promoting Christian-inspired publications, audiovisual material
            and radio- programmes, by educating others to use the media
            responsibly.
          </Card.Text>
          <Card.Text style={{ lineHeight: 1.5 }}>
            We also support Christian communications projects aimed at
            disseminating the Gospel among the poor in our own area as well as
            in other countries.
          </Card.Text>
        </Card.Body>
      </Card>
      <Container>
        <Row xs={1} md={3} className="g-4">
          {images.map((image, idx) => {
            return (
              <Col key={idx}>
                <Card className="m-3 rounded-0 ">
                  <Card.Img
                    variant="top"
                    src={`${image.image_url}`}
                    // alt={founder.name}
                    style={{ objectFit: true }}
                    className="rounded-0"
                  />
                  <Card.Body>
                    <a className="btn button-gradient" role={Button} href="#">
                      Read More
                    </a>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
      <div
        className="divider"
        style={{ borderBottom: "none", maxWidth: "25rem", margin: "2rem auto" }}
      >
        <h1 style={{ display: "block", margin: "1rem auto", color: "#005ca9" }} className="text-start">
          Connect with us
        </h1>
      </div>

      <Container>
        <SocialMediaIcons fonts="#d9001b" display={styles.ul} />
      </Container>
    </>
  );
}

export default CooperatorsMission;
